import $ from 'jquery';
import { localisedPath } from 'common/url_locale_helper';

export default class MobileMenu {
  constructor(element, options) {
    this.element = element;
    this.options = {
      backLabel: 'Back',
      // Change to "true" to use the active item as back link label.
      useActiveItemAsBackLabel: true,
      ...options,
    };
    this.open = false;

    this.initialize();
  }

  initialize() {
    this.setElements();
    this.attachEvents();

    if (this.options.useActiveItemAsBackLabel) {
      this.setActiveItemAsBackLabel();
    }
  }

  setElements() {
    this.$el = $(this.element);
    this.$menu = this.$el.children('ul.multi-list-menu__menu');
    this.$menuItems = this.$menu.find('li:not(.multi-list-back)');
    const textLinkClasses = `${
      this.options.textLinkClasses
    } multi-list-text-link`;
    this.$el.find('ul.multi-list-menu__submenu').prepend(
      `<li class="multi-list-back">
        <div class="flex-wrapper">
          <div class="multi-list-back-btn-icon"/>
          <a href="#" class="multi-list-back-btn ${textLinkClasses} intl-text">
          ${this.options.backLabel}
          </a>
        </div>
      </li>`
    );
    this.$back = this.$menu.find('li.multi-list-back');
    this.$subMenuItems = this.$menu.find('.multi-list-text-link--more');
  }

  setActiveItemAsBackLabel() {
    this.$back.each(function() {
      const $this = $(this);
      const parentLabel = $this
        .parents('li:first')
        .find('a:first')
        .text();

      $this.find('a').html(parentLabel);
    });
  }

  attachEvents() {
    this.$menuItems.on('click', e => {
      this.onMenuItemClick($(e.currentTarget), e);
    });

    this.$back.on('click', e => {
      this.onBackClick($(e.currentTarget), e);
    });

    // Prevent scroll changes on clicks that lead to submenus.
    this.$subMenuItems.on('click', e => {
      e.preventDefault();
    });
  }

  sendLogoutRequest(url) {
    $.ajax({
      url,
      method: 'DELETE',
      success: () => {
        analytics.track('User Logged Out');
        setTimeout(() => {
          window.location.assign(localisedPath('/'));
        }, 200);
      },
      beforeSend: xhr => {
        xhr.setRequestHeader(
          'X-CSRF-Token',
          $('meta[name="csrf-token"]').attr('content')
        );
      },
    });
  }

  onMenuItemClick(target, event) {
    event && event.stopPropagation();
    const $submenu = target.children('ul.multi-list-menu__submenu');

    // Only go to the next menu level if one exists AND the link isn't the
    // one we added specifically for navigating to parent item pages.
    if (
      $submenu.length > 0 &&
      !target.hasClass('multi-list-menu__subview--open')
    ) {
      this.$menu.addClass('multi-list-menu__subview');
      target
        .addClass('multi-list-menu__subview--open')
        .parents('.multi-list-menu__subview--open:first')
        .removeClass('multi-list-menu__subview--open')
        .addClass('multi-list-menu__subview');
      return false;
    }
    this.onLinkClick(target, event);
  }

  onLinkClick(item, event) {
    const anchor = item.find('a')[0];
    if (anchor && anchor.getAttribute('data-method') === 'delete') {
      event && event.preventDefault();
      this.sendLogoutRequest(anchor.getAttribute('href'));
      return;
    }

    // Ignore back link clicks.
    if (item.hasClass('multi-list-menu__subview--open')) {
      return;
    }

    // Close and reset the menu on link clicks.
    this.options.toggleSidebar();
    this.resetMenu(item);
  }

  resetMenu(item) {
    item
      .removeClass('multi-list-menu__subview--open')
      .parents('.multi-list-menu__subview--open')
      .removeClass('multi-list-menu__subview--open');
    this.$menu
      .removeClass('multi-list-menu__subview')
      .children('.multi-list-menu__subview')
      .removeClass('multi-list-menu__subview');
  }

  onBackClick(target) {
    const $submenu = target.parents('ul.multi-list-menu__submenu:first');
    const $item = $submenu.parent();

    setTimeout(() => {
      $item.removeClass('multi-list-menu__subview--open');

      const $subview = target.parents('.multi-list-menu__subview:first');
      if ($subview.is('li')) {
        $subview.addClass('multi-list-menu__subview--open');
      }
      $subview.removeClass('multi-list-menu__subview');
    });

    return false;
  }

  closeMenu() {
    if (this.open) {
      this.$menu.removeClass('multi-list-menu__menu--open');
      this.$el.removeClass('multi-list-active');

      this.open = false;
    }
  }

  openMenu() {
    if (!this.open) {
      this.$menu.addClass('multi-list-menu__menu--open');
      this.$el.addClass('multi-list-active');
      this.open = true;
    }
  }
}
